exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-sync-scrollbar=\"main\"] .el-table__body-wrapper {\n  overflow-x: hidden!important;\n}\n[data-sync-scrollbar=\"footer\"] .el-table__body-wrapper {\n  z-index:3;\n}\n[data-sync-scrollbar] .el-table__fixed {\n  height: 100%!important;\n}\n[data-sync-scrollbar=\"footer\"] thead {\n  display: none\n}\n[data-sync-scrollbar=\"summaries\"] .el-table__body-wrapper {\n  overflow: hidden;\n}\n[data-sync-scrollbar=\"summaries\"] thead th {\n  background-color: #f5f7fa\n}\n", ""]);

// exports
